<template>
  <section class="Timeline">
    <!-- {{store.state.user.progress}} -->
    <div :class="['Timeline-step', 'Timeline-step--room', { 'visited': store.state.user.progress >= 0 } ,  { 'active': store.state.user.progress < 3 }]"></div>
    <div :class="['Timeline-step', 'Timeline-step--kp', { 'visited': store.state.user.progress >= 1 }]"></div>
    <div :class="['Timeline-step', 'Timeline-step--kp', { 'visited': store.state.user.progress >= 2 }]"></div>
    <div :class="['Timeline-step', 'Timeline-step--kp', { 'visited': store.state.user.progress >= 3 }]"></div>
    <div :class="['Timeline-step', 'Timeline-step--room', { 'visited': store.state.user.progress >= 4 } ,  { 'active': store.state.user.progress >= 3 }]"></div>
    <div :class="['Timeline-step', 'Timeline-step--kp', { 'visited': store.state.user.progress >= 4 }]"></div>
    <div :class="['Timeline-step', 'Timeline-step--kp', { 'visited': store.state.user.progress >= 5 }]"></div>
  </section>
</template>

<script>

export default ({
  inject: ['store']
})
</script>

<style lang="stylus" scoped>
.Timeline
  display flex
  position absolute
  bottom 5%
  left 50%
  transform translateX(-50%)
  align-items center
  &-step
    border-radius 30px
    width 10px
    height 10px
    background transparent
    margin 0 10px
    position relative
    border 2px solid white
    &--room
      width 25px
      height 25px
      &::after
        content ' '
        height 6px
        width 6px
        border-radius 10px
        background white
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)

    &--kp
      background-color black
      &::before
        content ' '
        height 1px
        width 39px
        // background white
        background-image: linear-gradient(to right, black 60%, white 0%)
        background-position: bottom
        background-size: 4px 4px
        background-repeat: repeat-x
        position absolute
        // border-bottom 1px dotted white
        top 50%
        transform translateY(-50%)
        left -31px
        z-index -1
  .visited
    background rgba(255, 255, 255, 0.6)
  .active
    background rgba(255, 255, 255, 1.0)


  
</style>